import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { pushRoute } from "@/lib/bugContext";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    pushRoute(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}

export function AppLayout() {
  return (
    <SidebarProvider>
      <div className="flex h-screen w-full bg-background overflow-hidden">
        <AppSidebar />
        <main className="flex-1 min-h-0 overflow-y-auto" style={{ backgroundImage: 'var(--bg-stripe-pattern)' }}>
          <RouteTracker />
          <Outlet />
        </main>
      </div>
    </SidebarProvider>
  );
}
